
const routesNew =  [{
        path: '/info_servicios',
        name: 'servicios',
        component: () => import('../components/Reporte/Combustible/InfoServicios.vue'),
        meta: {
            libre : true,
            title: 'R. Servicios | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/info_orden',
        name: 'infordenes',
        component: () => import('../components/Reporte/Combustible/InfoOrdenes.vue'),
        meta: {
            libre : true,
            title: 'R. Ordenes | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/info_combustible',
        name: 'combustible',
        component: () => import('../components/Reporte/Combustible/InfoCombustible.vue'),
        meta: {
            libre : true,
            title: 'R. Combustible | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/info_combustible_general',
        name: 'infocomb',
        component: () => import('../components/Reporte/Combustible/InfoCombGen.vue'),
        meta: {
            libre : true,
            title: 'R. Ordenes | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        },
    }, {
        path: '/info_servicios_vehiculos',
        name: 'infovehi',
        component: () => import('../components/Reporte/Combustible/InfoServiciosVehi.vue'),
        meta: {
            libre : true,
            title: 'R. Vehículos | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'Inicio | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true,
            tab: false,
            closeable: false
        }
    }, {
        path: '/cargo_empleado',
        name: 'cargo_empleado',
        component: () => import('../components/Empleado/Cargo_Empleado.vue'),
        meta: {
            administrador :true,
            operador : true,
            title: 'E. Cargos | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/tipo_servicio',
        name: 'tipo_servicio',
        component: () => import('../components/Combustible/Categoria/Tipo_Servicio.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'T. Servicio | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/empleado',
        name: 'empleado',
        component: () => import('../components/Empleado/Empleado_Class.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'Empleados | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/tipo_orden',
        name: 'tipo_orden',
        component: () => import('../components/Combustible/Categoria/Tipo_Orden.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'T. Orden | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/vehiculo',
        name: 'vehiculo',
        component: () => import('../components/Combustible/Vehiculo/Vehiculo_Class.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'Vehiculos | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/tipo_combustible',
        name: 'tipo_combustible',
        component: () => import('../components/Combustible/Vehiculo/Tipo_Combustible.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'T. Combus  | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/ordenes',
        name: 'ordenes',
        component: () => import('../components/Combustible/Orden/Orden_.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'Ordenes | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/comprobantes',
        name: 'comprobantes',
        component: () => import('../components/Comprobante/Comprobante.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'Comp. | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/reporte',
        name: 'reporte',
        component: () => import('../components/Reporte/Combustible/Reporte.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'Reportes | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/reporte_comprobante',
        name: 'reporte_comprobante',
        component: () => import('../components/Reporte/Comprobante/Reporte.vue'),
        meta: {
            administrador : true,
            operador : true,
            title: 'R&C | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/roles',
        name: 'roles',
        component: () => import('../components/Usuario/Rol.vue'),
        meta: {
            administrador : true,
            title: 'Roles | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    }, {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import('../components/Usuario/Usuario.vue'),
        meta: {
            administrador : true,
            title: 'Usuarios | S.I Flota Vehicular',
            tabClass: 'tab-router',
            keepAlive: true
        }
    },
]

export default routesNew
